import React from "react";
import logo from "./../../images/budgetify_logo.png";
import "./styles.css";
import { Table } from "react-bootstrap";
import { FaTwitter } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

const AboutPageContent = () => {
  return (
    <div className="aboutContainer">
      <div className="col-md-6 text-left">
        <h1>About Us</h1>
        <p><em>See the team behind Budgetify.</em></p>
      </div>
      <div>
        <img src={logo} alt="Budgetify Logo" className="logo" />
        <Table className="table">
          <thead>
            <tr className="header">
              <th>Team Members: </th>
              <th>Description: </th>
            </tr>
          </thead>
          <tbody>
            <tr className="header">
              <td>Eugene</td>
              <td>Team Lead and repo owner</td>
            </tr>
            <tr className="header">
              <td>Esther</td>
              <td>
                Developer with strong web development skills and good work ethic
              </td>
            </tr>
            <tr className="header">
              <td>Ronald</td>
              <td>Developer that pioneered this project idea</td>
            </tr>
            <tr className="header">
              <td>Chen</td>
              <td>
                Developer with strong skills in database and data management
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <footer className="container background-black">
        <div className="container text-center text-md-start mt-5">
          <div className="row mt-3">
            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
              <p className="text-uppercase fw-bold">Seneca College</p>
              <hr className="mb-4 mt-0 d-inline-block mx-auto" />
              <p>Computer Programming and Analysis</p>
            </div>

            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              <div className="me-5 mb-4">
                <span>Get connected with us on social networks:</span>
              </div>
            </div>

            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
              <div className="text-center p-3 text-white background-black">
                © 2022: Budgetify
              </div>
              <div>
                <a
                  href="https://www.facebook.com/senecacollege/"
                  className="text-white me-4"
                >
                  <FaFacebook />
                  Facebook
                  <br />
                </a>
                <a
                  href="https://twitter.com/senecacollege/"
                  className="text-white me-4"
                >
                  <FaTwitter />
                  Twitter
                  <br />
                </a>
                <a
                  href="https://www.senecacollege.ca/home.html"
                  className="text-white me-4"
                >
                  <FaGoogle />
                  Google
                  <br />
                </a>
                <a
                  href="https://www.github.com/ycechungAI"
                  className="text-white me-4"
                >
                  <FaGithub />
                  Github
                  <br />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPageContent;
